import { useCallback, useMemo } from 'react';
import { useStore, getBezierPath } from 'reactflow';
import { getEdgeParams } from '../helpers/getEdgeParams';
import { ConnectorButton } from './ConnectorButton';
import { useTheme } from 'styled-components';
import { CanvasEdge } from '../Canvas';

export type FloatingEdgeProps = CanvasEdge;

export const FloatingEdge = ({ id, source, target, markerEnd, data }: FloatingEdgeProps) => {
  const theme = useTheme();

  const style = useMemo(
    () => ({
      fill: 'none',
      stroke: theme.vars.newColor.darkGS3,
      strokeWidth: 3,
    }),
    [theme.vars.newColor.darkGS3],
  );

  const sourceNode = useStore(useCallback(store => store.nodeInternals.get(source), [source]));
  const targetNode = useStore(useCallback(store => store.nodeInternals.get(target), [target]));

  const { connectorButtonProps } = data ?? {};

  if (!sourceNode || !targetNode) {
    return null;
  }

  const { sx, sy, tx, ty, sourcePos, targetPos } = getEdgeParams(sourceNode, targetNode);

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX: sx,
    sourceY: sy,
    sourcePosition: sourcePos,
    targetPosition: targetPos,
    targetX: tx,
    targetY: ty,
  });

  return (
    <>
      <path id={id} className="react-flow__edge-path" d={edgePath} markerEnd={markerEnd as string} style={style} />
      <ConnectorButton labelX={labelX} labelY={labelY} {...connectorButtonProps} />
    </>
  );
};
